<p8-settings-page>
  <p8-settings-header [titlePath]="['Documents', 'Editer']"></p8-settings-header>

  <p8-bdc-document-form *ngIf="document" [title]="document.title"></p8-bdc-document-form>

  <p8-settings-footer>
    <button mat-raised-button
            color="accent"
            (click)="onSubmit()"
    >ENREGISTRER</button>

    <button mat-button (click)="onCancel()">RETOUR</button>
  </p8-settings-footer>
</p8-settings-page>
